import { useState } from "react";
import { Sparkles, UserCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { PRIORITY_LABEL, SEVERITY_COLOR } from "@/lib/i18n";

const OPTIONS = [
  { v: "critical", label: "ALTA" },
  { v: "warning", label: "MEDIA" },
  { v: "info", label: "BAJA" },
];

// Semáforo rojo/amarillo/verde de prioridad de una novedad, con indicador de
// si fue clasificada por IA o corregida por una persona, y control inline
// para que admin/supervisor la corrijan a mano (queda registrado quién y cuándo).
export function NewsSeverityBadge({ news, editable = false, onUpdated }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const correct = async (severity) => {
    if (severity === news.severity) { setOpen(false); return; }
    setBusy(true);
    try {
      const { data } = await api.patch(`/news/${news.id}/severity`, { severity });
      toast.success("Prioridad corregida");
      onUpdated && onUpdated(data);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); setOpen(false); }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
      <span className={`badge ${SEVERITY_COLOR[news.severity] || "gray"}`} data-testid={`news-severity-badge-${news.id}`}>
        {PRIORITY_LABEL[news.severity] || news.severity}
      </span>
      <span style={{ fontSize: 9, color: "var(--invict-text-muted)", display: "flex", alignItems: "center", gap: 3 }} data-testid={`news-severity-source-${news.id}`}>
        {news.severity_source === "manual" ? (
          <><UserCheck size={10} /> {news.severity_corrected_by_name ? `Corregido por ${news.severity_corrected_by_name}` : "Manual"}</>
        ) : (
          <><Sparkles size={10} /> Sugerido por IA</>
        )}
      </span>
      {editable && (
        <div style={{ position: "relative" }}>
          <button type="button" onClick={() => setOpen((o) => !o)} className="btn-ghost" style={{ padding: "2px 8px", fontSize: 9 }} data-testid={`news-correct-open-${news.id}`}>
            Corregir
          </button>
          {open && (
            <div style={{ position: "absolute", right: 0, top: "100%", zIndex: 5, background: "#fff", border: "1px solid var(--invict-bone-3)", borderRadius: 4, padding: 6, display: "flex", gap: 4, boxShadow: "0 4px 14px rgba(0,0,0,0.12)" }}>
              {OPTIONS.map((o) => (
                <button key={o.v} type="button" disabled={busy} onClick={() => correct(o.v)}
                  className={`badge ${SEVERITY_COLOR[o.v]}`} style={{ cursor: "pointer", border: "none", opacity: news.severity === o.v ? 1 : 0.55 }}
                  data-testid={`news-correct-severity-${news.id}-${o.v}`}>
                  {o.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
